import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TUserNotification } from '../api-ducks/user-notifications-duck/types-user-notifications';

export type SplashScreenNotificationsState = {
  notifications: TUserNotification[];
  viewedNotifications: TUserNotification[];
};

const initialState: SplashScreenNotificationsState = { notifications: [], viewedNotifications: [] };

const splashScreenNotificationsDuck = createSlice({
  name: 'splashScreenNotifications',
  initialState: initialState,
  reducers: {
    addSplashScreenNotification: (state, action: PayloadAction<TUserNotification>) => {
      const exists =
        state.notifications.some((n) => n.notificationReferenceId === action.payload.notificationReferenceId) ||
        state.viewedNotifications.some((n) => n.notificationReferenceId === action.payload.notificationReferenceId);
      if (exists) {
        return state;
      }
      // Since the notification isn't in the existing notifications or viewedNotifications, add it.
      return { ...state, notifications: [...state.notifications, action.payload] };
    },
    clearAllSplashScreenNotifications: (state) => {
      return { notifications: [], viewedNotifications: [...state.viewedNotifications, ...state.notifications] };
    },
    resetForImpersonation: () => initialState,
  },
});

export const { addSplashScreenNotification, clearAllSplashScreenNotifications, resetForImpersonation } = splashScreenNotificationsDuck.actions;

export default splashScreenNotificationsDuck.reducer;
